import { Component } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-recent-project',
  templateUrl: './recent-project.component.html',
  styleUrl: './recent-project.component.scss'
})
export class RecentProjectComponent {
  constructor() { }
  ngOnInit(): void {
    /* magnificPopup img view */
    if ($(".popup-image").length > 0) {
      $(".popup-image").magnificPopup({
        type: "image",
        mainClass: 'mfp-zoom-in',
        removalDelay: 260,
        gallery: {
          enabled: true,
        },
      });
    }
    /* magnificPopup video view */
    if ($(".popup-video").length > 0) {
      $(".popup-video").magnificPopup({
        type: "iframe",
      });
    }
    /* magnificPopup video view */
    if ($(".popup-content").length > 0) {
      $(".popup-content").magnificPopup({
        type: "inline",
        midClick: true,
      });
    }
  }
}
